<template>
  <el-container class="container">

    <!--=========================header区域=========================-->
    <el-header class="header flex-between">
      <img width="150"
           src="../../assets/logo.png"
           alt="">
      <h3 class="live-title">《如何基于RISC-V设计一款AloT边缘计算芯片》 | AI芯片设计系列课</h3>
      <div class="deal-wrap">
        <div class="user-info">
          <img class="avatar"
               src="../../assets/logo.png"
               alt="">
          <span class="username">曹永杰</span>
        </div>
        <el-dropdown class="deal-btn-wrap"
                     :hide-on-click="false">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              禁言模式
              <el-switch v-model="isForbidden"
                         active-color="#13ce66"
                         inactive-color="#ccc">
              </el-switch>
            </el-dropdown-item>
            <el-dropdown-item>结束直播</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>

      <!--=========================左侧讲课区域=========================-->
      <el-aside class="aside">
        <recorder></recorder>
        <div class="course-room aside-block">
          <div class="little-title tc">讲解</div>
          <div class="live-list">
            <div class="live-msg-list">
              <msg-list></msg-list>
            </div>
          </div>
        </div>
        <div class="send-wrap aside-block">
          <div class="upload-file">
            <span @click="uploadFileDialogVisible=true">
              <i class="el-icon-folder"></i>
              文件
            </span>
          </div>
          <div class="send-message-wrap">
            <textarea class="textarea"
                      placeholder="输入内容"
                      rows="3"
                      v-model="sendMessage"></textarea>
            <button class="send-btn">
              <span>发送</span>
            </button>
          </div>
        </div>
      </el-aside>

      <!--=========================直播PPT区域=========================-->
      <el-main class="main">
        <div class="main-header">
          <div class="live-time">倒计时：2019-07-26 16:03:57</div>
          <div class="watch-num">
            <i class="el-icon-user el-icon--left"></i>
            参与人数：21人
          </div>
        </div>
        <div class="course-ware">
          <div class="show-container pic-url"
               :style="{background: `url(${picList[curPicIndex]}) center center / contain no-repeat #353535`}">
            <div class="left-handle big-pic-handle"
                 v-show="picList[curPicIndex]"
                 @click="prevPic">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="right-handle big-pic-handle"
                 v-show="picList[curPicIndex]"
                 @click="nextPic">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="operate-container">
            <div class="thumb-wrap">
              <div class="thumb-list-wrap">
                <i class="el-icon-arrow-left thumb-handle"></i>
                <draggable class="thumb-list"
                           element="ul"
                           v-model="picList"
                           @start="picSortStart">
                  <li v-for="(item,index) in picList"
                      :key="index"
                      :class="{'on': index==curPicIndex}"
                      @click="selectPic(index)">
                    <div class="pic-url"
                         :style="{background: `url(${item}) center center / contain no-repeat #353535`}"></div>
                    <p>{{index+1}}</p>
                    <div class="del-pic-wrap"
                         @click.stop="delPic(index)">删除</div>
                  </li>
                </draggable>

                <i class="el-icon-arrow-right thumb-handle"></i>
              </div>
            </div>
            <el-upload class="upload-wrap"
                       name="imageFile"
                       action="/admin/upload/image"
                       accept="image/*"
                       :show-file-list="false"
                       multiple
                       :before-upload="picBeforeUpload"
                       :on-success="picUploadSuccess">
              <div class="add-pic-btn">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </div>
        </div>
      </el-main>

      <!--=========================右侧用户讨论区域=========================-->
      <el-aside class="aside">
        <section class="aside-block user-room">
          <el-tabs v-model="userRoomType"
                   type="border-card"
                   @tab-click="changeRoom"
                   :stretch="true">
            <el-tab-pane label="讨论组"
                         name="1">
              <el-select v-model="discuss_room.status"
                         placeholder="请选择">
                <el-option v-for="item in options.discuss_room_status"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>

              <div class="live-list">
                <div class="live-msg-list">
                  <ul>
                    <msg-list :is_user="true"></msg-list>
                  </ul>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="问答"
                         name="2">
              <el-select v-model="reply_room.status"
                         placeholder="请选择">
                <el-option v-for="item in options.reply_room_status"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <div class="live-list">
                <div class="live-msg-list">
                  <reply-msg-list></reply-msg-list>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </section>
        <section class="aside-block send-wrap">
          <div class="upload-file"
               v-if="userRoomType==1">
            <span @click="uploadFileDialogVisible=true">
              <i class="el-icon-folder"></i>
              文件
            </span>
          </div>
          <div class="send-message-wrap"
               :class="{disabled:userRoomType!=1}">
            <textarea class="textarea"
                      placeholder="输入内容"
                      rows="3"
                      v-model="sendMessage"></textarea>
            <button class="send-btn">
              <span>发送</span>
            </button>
          </div>
        </section>
      </el-aside>
    </el-container>

    <upload-file-dialog :visible.sync="uploadFileDialogVisible"></upload-file-dialog>
  </el-container>
</template>

<script>
import Recorder from './components/recorder'
import MsgList from './components/msg-list'
import ReplyMsgList from './components/reply-msg-list'
import UploadFileDialog from './components/upload-file-dialog'
import Draggable from 'vuedraggable'
import util from '@/base/js/util'
import {
  _getLive,
  _updateppt,
  _liveForbidden,
  _liveBlack,
  _liveRest,
  _sendLiveIm,
  _getLiveDiscuss,
  _getLiveQa,
  _getLiveClass
} from '@/api/live'

//图片上传大小限制单位：B
const MAX_FILE_LIMIT = 8 * 1024 * 1024

export default {
  data () {
    return {
      rec: null,
      record_status: 0,
      sendMessage: '',
      curPicIndex: -1,
      uploadingNum: 0,
      userRoomType: '1',
      isForbidden: false,
      picList: [],
      uploadFileDialogVisible: false,
      discuss_room: {
        status: '1'
      },
      reply_room: {
        status: '2'
      },
      options: {
        discuss_room_status: [
          {
            label: '全部讨论内容',
            value: '1'
          },
          {
            label: '学员讨论内容',
            value: '2'
          },
          {
            label: '讲师讨论内容',
            value: '3'
          },
        ],
        reply_room_status: [
          {
            label: '全部问答',
            value: '1'
          },
          {
            label: '未回答',
            value: '2'
          },
          {
            label: '已回答',
            value: '3'
          },
        ],
      }
    }
  },
  computed: {
    course_id () {
      return this.$route.params.id
    }
  },
  created () {
    this.getLive()
  },
  mounted () {
  },
  methods: {
    //获取直播信息
    getLive () {
      _getLive({
        params: {
          course_id: this.course_id
        }
      }).then(res => {
        console.log(res)
      })
    },
    //选中ppt
    selectPic (index) {
      this.curPicIndex = index
    },
    //上一张
    prevPic () {
      if (this.curPicIndex > 0) {
        this.curPicIndex--
      } else {
        this.$message.warning('已经是第一张了！')
      }
    },
    //下一张
    nextPic () {
      if (this.curPicIndex < this.picList.length - 1) {
        this.curPicIndex++
      } else {
        this.$message.warning('已经是最后一张了！')
      }
    },
    //删除图片
    delPic (index) {
      this.$confirm('你确定要删除此张PPT吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.picList.splice(index, 1)
      }).catch(() => { })
    },
    picSortStart () {
      this.curPicIndex = -1
    },
    //上传前检查文件大小
    picBeforeUpload (file) {
      if (file.size > MAX_FILE_LIMIT) {
        this.$message.error(`图片大小超过${util.formatSize(MAX_FILE_LIMIT)}限制`)
        return false
      }
      this.uploadingNum++
      this.startUploadingWindow()
    },
    //打开上传中弹窗
    startUploadingWindow () {
      if (!this.picUploadNotify) {
        this.picUploadNotify = this.$notify({
          title: '正在上传',
          duration: 0,
          showClose: false,
          iconClass: 'el-icon-loading',
          dangerouslyUseHTMLString: true,
          message: `<div>还有<span class="red">${this.uploadingNum}</span>张图片等待上传中...</div>`,
          onClose: () => {
            this.picUploadNotify = null
          }
        })
      }
    },
    //关闭上传中弹窗
    closeUploadingWindow () {
      if (this.picUploadNotify && this.uploadingNum <= 0) {
        this.picUploadNotify.close()
      }
    },
    //上传成功
    picUploadSuccess (response, file, fileList) {
      if (response.resultCode == 0) {
        this.picList.push(response.result.url)
        this.uploadingNum--
        this.closeUploadingWindow()
      } else {
        this.$message.error('上传失败')
        this.uploadingNum--
        this.closeUploadingWindow()
      }
    },
    changeRoom () {

    }
  },
  components: {
    Recorder,
    MsgList,
    ReplyMsgList,
    UploadFileDialog,
    Draggable
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  min-height: 600px;
}
.header {
  background-color: #ffffff;
}
.aside {
  width: 17.5% !important;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.live-title {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.username {
  margin-left: 10px;
}
.deal-wrap {
  display: flex;
  align-items: center;
}
.deal-btn-wrap {
  margin-left: 30px;
}
.aside-block {
  padding: 15px 0;
  background-color: #ffffff;
  & + .aside-block {
    margin-top: 10px;
  }
}
// 左侧样式
.course-room {
  flex: 1;
  display: flex;
  flex-direction: column;
  h3 {
    font-size: 16px;
    font-weight: bold;
    color: #000000;
  }
  p {
    margin-top: 5px;
  }
}
.live-list {
  flex: 1;
  position: relative;
  .live-msg-list {
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
.send-wrap {
  padding: 10px;
  .upload-file {
    cursor: pointer;
    color: @blue;
  }
  .send-message-wrap {
    margin: 10px 0;
    display: flex;
    align-items: stretch;
    position: relative;
    &.disabled {
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.3);
        z-index: 2;
      }
    }
    .textarea {
      flex: 1;
      overflow: auto;
      outline: 0;
      resize: none;
      flex: 1;
      height: 56px;
      padding-top: 8px;
      padding-left: 8px;
      background: #f5f7fa;
      border-radius: 4px;
      border: 0;
      font-size: 14px;
    }
  }
  .send-btn {
    width: 44px;
    background-color: @blue;
    color: #fff;
    border-radius: 0 4px 4px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    outline: none;
  }
}

// 中间区域样式
.main {
  margin: 10px 0;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}
.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 10px 20px;
  .live-time {
    background-color: #f4f4f5;
    color: #909399;
    padding: 5px 10px;
    border-radius: 4px;
  }
}
.course-ware {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.show-container {
  height: 73.17%;
  margin-bottom: 8px;
  background-color: #353535;
  position: relative;
  min-height: 247px !important;
}
.pic-url {
  max-width: 100%;
  height: 100%;
  background-position: 50% !important;
}
.operate-container {
  height: 19%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 16px 4px;
  display: flex;
}
.big-pic-handle {
  position: absolute;
  width: 32px;
  height: 100px;
  line-height: 100px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  font-size: 32px;
  color: #ffffff;
  cursor: pointer;
  i {
    font-weight: bold;
  }
  &.left-handle {
    left: 0;
  }
  &.right-handle {
    right: 0;
  }
}
.thumb-wrap {
  width: 85%;
  position: relative;
}
.thumb-list-wrap {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.thumb-handle {
  font-size: 32px;
  font-weight: bold;
  color: @gray;
}
.thumb-list {
  flex: 1;
  overflow-x: auto;
  display: flex;
  height: 100%;
  li {
    position: relative;
    min-width: 145px;
    height: 76.92%;
    min-height: 80px;
    background-color: #353535;
    cursor: pointer;
    margin-right: 10px;
    transition: 0.3s all;
    &.on {
      color: @blue;
      border: 2px solid @blue;
    }
    &:hover {
      .del-pic-wrap {
        height: 24px;
        visibility: visible;
      }
    }
    p {
      margin-top: 5px;
      text-align: center;
    }
  }
}
.del-pic-wrap {
  height: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 24px;
  color: #fff;
  cursor: pointer;
  transition: 0.3s height;
  visibility: hidden;
}
.upload-wrap {
  width: 15%;
}
.add-pic-btn {
  margin: 0 auto;
  width: 80%;
  height: 76.92%;
  background-color: @table-bg;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  cursor: pointer;
  color: @gray;
}

// 右侧样式
.user-room {
  padding-top: 0;
  flex: 1;
}
.reply-list {
  padding: 0 10px;
}
</style>

<style lang="less">
.operate-container {
  .upload-wrap {
    .el-upload {
      width: 100%;
      height: 100%;
    }
  }
}
.user-room {
  .el-tabs--border-card {
    height: 100%;
    box-shadow: none;
    border: none;
    display: flex;
    flex-direction: column;
  }
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child {
    margin-right: -1px;
  }
  .el-tabs--border-card > .el-tabs__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px 0 0;
    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .el-select {
      margin-bottom: 20px;
      margin: 0 10px 20px;
    }
  }
}
</style>

